module.exports = __webpack_public_path__ + "static/media/fitness-and-sports_2.20b06bdb.svg";